<template>
  <section-form
    v-if="section"
    :section="section"
    @save="$emit('saved')"
    @cancel="$emit('canceled')"
  ></section-form>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import SectionForm from "@/components/sections/SectionForm.vue";

export default {
  components: { SectionForm },
  mixins: [documentModelMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      section: null,
    };
  },
  emits: ["saved", "canceled"],
  mounted: function() {
    this.section = this.documentModel.findContentControl(parseInt(this.id, 10));
  },
};
</script>
